import type { SeverityLevel } from "../types";

interface SeverityBadgeProps {
  severity: SeverityLevel;
  size?: "sm" | "md";
}

const severityStyles: Record<
  SeverityLevel,
  {
    base: string;
    glow: string;
  }
> = {
  critical: {
    base: "border-red-400/20 bg-red-500/10 text-red-300",
    glow: "shadow-[0_0_12px_rgba(248,113,113,0.12)]",
  },
  high: {
    base: "border-orange-400/20 bg-orange-500/10 text-orange-300",
    glow: "shadow-[0_0_12px_rgba(251,146,60,0.12)]",
  },
  medium: {
    base: "border-amber-400/20 bg-amber-500/10 text-amber-300",
    glow: "shadow-[0_0_12px_rgba(252,211,77,0.10)]",
  },
  low: {
    base: "border-emerald-400/20 bg-emerald-500/10 text-emerald-300",
    glow: "shadow-[0_0_12px_rgba(52,211,153,0.10)]",
  },
};

export function SeverityBadge({
  severity,
  size = "md",
}: SeverityBadgeProps) {
  const style = severityStyles[severity];

  const sizeClasses =
    size === "sm"
      ? "text-[11px] px-2.5 py-0.5"
      : "text-xs px-3 py-1";

  return (
    <span
      className={`inline-flex items-center rounded-full border font-semibold uppercase tracking-[0.16em] transition ${style.base} ${style.glow} ${sizeClasses}`}
    >
      {severity}
    </span>
  );
}
